import { Grid, makeStyles } from '@material-ui/core'
import DazzedHeading14 from 'components/common/text/DazzedHeading14'
import DazzedHeading16 from 'components/common/text/DazzedHeading16'
import DazzedHeading18 from 'components/common/text/DazzedHeading18'
import React from 'react'
import { useTranslation } from 'react-i18next'
import SparkleIcon from '../icons/SparkleIcon'
import DateFilter from '../DateFilter'
import CopilotUtilization from './CopilotUtilization'

const useStyles = makeStyles(() => ({
  root: {
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 15,
    height: 'var(--copilot-header-height)'
  },
  headerItem: {
    marginLeft: 8
  },
  headerItemMargined: {
    marginLeft: 30
  },
  dateFilterContainer: {
    marginLeft: 5,
    display: 'flex',
    alignItems: 'center'
  }
}))

const CopilotControlHeader = ({ pastXDays, setPastXDays, practiceGuidelinesConfiguration }) => {
  const { t } = useTranslation()
  const classes = useStyles()

  return (
    <Grid container item xs={12} sm={12} md={12} lg={12} className={classes.root}>
      <Grid container item direction="column" wrap="nowrap" xs={9} sm={9} md={9} lg={9}>
        <Grid item container alignItems="center" justifyContent="flex-start">
          <SparkleIcon />
          <DazzedHeading18 className={classes.headerItem}>{t('pages.copilotControl.mainPage.title')}</DazzedHeading18>
          <DazzedHeading18 className={classes.headerItem}>|</DazzedHeading18>
          <DazzedHeading16 className={classes.headerItem} semibold>
            {t('pages.copilotControl.mainPage.subtitle')}
          </DazzedHeading16>
          <DazzedHeading14 className={classes.headerItemMargined} regular>
            {t('pages.copilotControl.mainPage.description')}
          </DazzedHeading14>
        </Grid>
        <Grid item>
          <Grid container id="copilot-datefilter" className={classes.dateFilterContainer}>
            <DateFilter pastXDays={pastXDays} onChange={setPastXDays} />
          </Grid>
        </Grid>
      </Grid>
      <CopilotUtilization practiceGuidelinesConfiguration={practiceGuidelinesConfiguration} />
    </Grid>
  )
}

export default CopilotControlHeader
